/**
 * Created by PhpStorm on 29.05.2017.
 * Author: Shabalin Pavel
 * Email: aisamiery@gmail.com
 */
'use strict';

require('../core/core');
require('../../modules/forms/forms');
require('../../modules/maps/maps');
require('../../modals/slider/slider');
require('../../helpers/show-modal-message/show-modal-message');

require('../../models/blog/post');

angular.module('far.blog', [
    'far.core',
    'far.models.post',
    'far.helpers.showModalMessage',
    'far.modals.slider',
]);

angular.module('far.blog').controller('BlogFrontController', function(Post, $uibModal) {
    var vm = {
        post: {},
        openSlider: openSlider,
        init: function(id) {
            vm.post = Post.get(id, function() {

            });
        }
    };

    function openSlider(slide) {
        $uibModal.open({
            templateUrl: '/modals/slider/slider.html',
            controller: 'SliderController as slider',
            resolve: {
                slides: function() {
                    return vm.post.slides_files;
                },
                selectedSlide: function() {
                    return slide;
                }
            }
        });
    }



    return vm;
});